<template>
    <!--This layout is used to define the basic structure of all the pages (views) a user can access after logging in -->
    <v-app id="content-app-ui">
        <Menu v-if="loggedIn"
              :drawer="drawer"
              @changeDrawer="changeDrawer"
              :cartNumberItems="cartNumberItems"
              :shopAvailable="shopAvailable"
              :displayMenuCatalog="displayMenuCatalog"
              @logout="logout"></Menu>

        <v-toolbar color="primary" clipped-left app>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title v-if="!displaySearchInput" class="text-lowercase">{{
                $vuetify.t($route.meta.toolbarTitle)
                }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- @modified ana.castro 2019.09.30 SCLAPP-22 -->
            <v-btn v-if="qrcodeAvailable && !displayMenuCatalog" icon right @click="goQrcode()">
                <v-icon>fal fa-qrcode</v-icon>
            </v-btn>

            <v-btn v-if="shopAvailable && displayMenuCatalog && !displaySearchInput" icon right
                   @click="openSearchInput()">
                <v-icon>fal fa-search</v-icon>
            </v-btn>
            <v-flex xs12 v-if="displaySearchInput" v-on:keyup="submitSearch">
                <v-text-field ref="searchInput" v-click-outside="clearSearch"
                              v-model="searchText"
                              clear-icon="fal fa-times"
                              clearable box
                              placeholder="Pesquisa"
                              type="text"
                              @click:append="applySearch"
                              @click:clear="clearSearch"
                ></v-text-field>
            </v-flex>
            <!-- @modified ana.castro 2020.11.29 The Search Icon is not necessary -->
            <!-- :append-icon="'fal fa-search'"-->

            <!-- @modified ana.castro 2020.10.14 SCLAPP-33 -->
            <v-btn v-if="shopAvailable && displayMenuCatalog && !displaySearchInput" icon right
                   @click="goShoppingCart()">
                <v-badge overlap>
                    <template v-slot:badge v-if="cartNumberItems > 0"><span
                            class="primary--text">{{ cartNumberItems }}</span></template>
                    <v-icon>fal fa-shopping-cart</v-icon>
                </v-badge>
            </v-btn>

        </v-toolbar>

        <v-content app>
            <v-container fluid grid-list-md>
                <router-view/>
            </v-container>
        </v-content>

        <v-dialog v-model="dialogLogout" persistent max-width="250px">
            <v-card>
                <v-card-title class="title">{{ $vuetify.t('$vuetify.authentication.end_session') }}</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="confirmLogout">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>

<script>
    //TODO mover isto para block css
    import "clientAppLayout"

    import {mapGetters} from 'vuex';
    import Menu from '../components/Menu.vue';

    export default {
        name: 'App',
        components: {Menu},
        data: () => ({
            dialogLogout: false,
            drawer: null,
            qrcodeAvailable: true,
            shopAvailable: false,
            loggedIn: false,
            searchInputVisible: false,
            show: false,
            searchText: '',
        }),
        methods: {
            logout() {
                this.dialogLogout = true;
            },
            confirmLogout() {
                this.$store.dispatch('authentication/logout');
                this.$router.push({name: "login"});
            },
            // @modified ana.castro 2019.09.30 SCLAPP-22
            goQrcode: function () {
                this.$router.push({name: 'qrcode'})
            },
            // @modified ana.castro 2020.10.14 SCLAPP-33
            goShoppingCart: function () {
                //The "catch" is to prevent the error Uncaught (in promise) NavigationDuplicated
                // which is triggered when the user clicks on the Shopping Cart,
                // despite being already on the Shopping Cart interface.
                // eslint-disable-next-line
                this.$router.push({name: 'order-cart'}).catch(err => {})
            },
            changeDrawer: function (drawer) {
                this.drawer = drawer;
            },
            openSearchInput: function () {
                this.searchInputVisible = true;
                this.$nextTick(() => {
                    this.focusSearchInput();
                });
            },
            applySearch() {
                this.$router.push({name: "shop-search-results", query: {search: this.searchText}})
                    .catch(() => {/* NavigationDuplicated if same search term used */
                    });
                this.clearSearch();
            },
            clearSearch() {
                this.$nextTick(() => (this.searchInputVisible = false))
            },
            submitSearch: function (e) {
                if (e.keyCode === 13) {
                    this.applySearch();
                }
            },
            focusSearchInput() {
                this.$refs.searchInput.focus();
            },
            updateStoreVar(state) {
                this.shopAvailable = state.configs.shopAvailable;
                this.qrcodeAvailable = state.configs.qrcodeMenu;
            }
        },
        // @modified ana.castro 2020.10.14 SCLAPP-33
        computed: {
            displayMenuCatalog: function () {
                return this.shopAvailable && this.$route.meta.context === 'shop';
            },
            displaySearchInput: function () {
                return this.searchInputVisible;
            },
            ...mapGetters({
                cartNumberItems: 'shop/cartSize',
            }),
        },
        directives: {
            //Source: https://stackoverflow.com/questions/36170425/detect-click-outside-element
            clickOutside: {
                bind: function (el, binding, vnode) {
                    el['data-first-click'] = 'a';
                    el.clickOutsideEvent = function (event) {
                        if (el['data-first-click'] === 'a') {
                            el['data-first-click'] = 'b';
                            return
                        }
                        // here I check that click was outside the el and his children
                        if (!(el === event.target || el.contains(event.target))) {
                            // and if it did, call method provided in attribute value
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.body.addEventListener('click', el.clickOutsideEvent)
                },
                unbind: function (el) {
                    document.body.removeEventListener('click', el.clickOutsideEvent)
                },
            }
        },
        mounted() {
            this.updateStoreVar(this.$store.state);

            this.$store.subscribe((mutation, state) => {
                switch (mutation.type) {
                    case 'configs/setGeneralConfig':
                        this.updateStoreVar(state);
                        break;
                }
            });

            // @modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions
            // In case a Non Authenticated User access the Terms and Conditions page, the menu should not be displayed
            this.loggedIn = localStorage.getItem('user');

        },
    }
</script>

<style lang="stylus">
    #keep
        .v-navigation-drawer__border
            display: none

    #content-app-ui
        background: #ffffff
        color: #000000

    //.application
    //    background: #15191c url(../assets/background.jpg) repeat-y 0 0 !important

    //background: #8C734B url(../assets/clients/011_wowfoods/background.png) no-repeat 0 0 !important


    /*.v-toolbar__content*/
    /*    height: 56px !important*/
    /*    border-bottom: 2px solid*/
    /*    margin-bottom: 8px*/
    /*    margin-left: 5px*/
    /*    margin-right: 5px*/

    .v-toolbar__content .v-btn--icon, .v-toolbar__extension .v-btn--icon
        margin: 0

    .v-toolbar,
    .v-toolbar .v-icon,
    .v-toolbar .v-input,
    .v-toolbar .v-input input
        color: #fff !important
        caret-color: #fff !important

    .v-toolbar .v-text-field--box input
        margin-top: 16px
        font-size: 21px

    .v-toolbar .v-input input::placeholder
        color: #c0c0c0 !important
        opacity: 1

    .v-navigation-drawer .v-list__tile__title
    .v-navigation-drawer .v-list__group__header__append-icon .v-icon
        color: #000 !important

    .v-navigation-drawer .v-list__group__items .v-list__tile__title
        font-weight 400 !important

    .v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon
        font-weight: 100

    .v-carousel__controls, .v-list
        background: transparent !important

    .v-carousel
        box-shadow: none !important

    .v-carousel__next .v-btn i, .v-carousel__prev .v-btn i, .v-carousel__controls .v-btn
        color: #ccc !important;
        font-weight: 400;

    #points
        width: 150px
        height: auto
        background-size: cover

        h2
            font-size: 55px;
            font-weight: 800

    input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button
        -webkit-appearance: none

    .menu-social-links
        text-align center
        margin-top 30px

        a
            text-decoration: none
            margin-right 20px
            margin-left 20px

        i
            width: 24px
            font-size: 30px

    .v-expansion-panel
        box-shadow: none

    .v-expansion-panel__header
        padding: 0

    .username-pre,
    .username-pos
        display: none !important

    .v-list__group__header__append-icon .v-icon
        font-weight: 100;

    .v-toolbar__content .v-btn--icon.v-btn--right
        margin-left: 10px

    .store-address-distance
        text-align center

    .alert-list-tile
        .v-icon
            font-weight bold

        .v-list__tile__title
            font-weight 500
            text-align center
            overflow: visible;
            white-space: normal;
            height: auto;

        .v-btn--flat
            font-weight bold

    /* CATALOG CSS*/

    .theme--dark.v-sheet
        background-color: transparent;

    .theme--dark.v-sheet.catalog-group-card
        background-color: #424242;

    .catalog-group-card
        background-color: transparent
        cursor: pointer

        .v-card__title
            display: block;

        .headline
            width: 100%
            text-align: center
            font-size: 20px !important
            font-weight: 600;


    .catalog-group-card.no-card-image
        min-height: 250px

        .v-card__title
            padding-top: 100px;

    .catalog-item-card
        background-color: transparent
        cursor: pointer

        .headline
            font-size: 20px !important
            height: 65px
            overflow: hidden
            font-weight: 600

        .catalog-item-price
            font-size: 25px
            font-weight: 400

    .catalog-group-card:hover, .catalog-item-card:hover
        .headline
            text-decoration: underline

    .catalog-item-title
        font-weight 600

    .catalog-item-image-promo
        position: absolute
        top: 5px
        right: 5px
        padding: 7px 9px
        border-radius: 7px

    @media only screen and (max-width: 768px)
        .catalog-item-menu-level-panel
            .v-list__tile, .v-list
                padding: 0px

                .v-list__tile__avatar
                    min-width: auto
                .v-list__tile__title
                    font-size: 14px


    /*SHOPPING CART*/
    /*Cart Counter Badges*/
    .v-toolbar__content .v-badge__badge, .v-navigation-drawer .v-chip__content
        background-color: #fff !important

    .shop-cart-removeall
        color: #D32F2F !important
        font-weight bold

        .v-icon
            color: #D32F2F !important
            font-weight bold

    .shop-cart-item-list .v-list__tile__action
        min-width auto

    .shop-cart-item-name
        font-weight 500;

    .shop-cart-item-quantity
        width: 50px;

    .shop-cart-item-quantity-input
        width: 40px;

        input
            text-align: center;
            font-weight: bold;
            font-size: 19px;

    .shop-cart-item-quantity-input .v-input__slot
        text-align: center !important;
        display: block;

    .shop-cart-item-total
        width: 100px;
        font-weight 600;

    .shop-cart-item-list
        .no-stock
            .shop-cart-item-name
                text-decoration: line-through

            .v-list__tile__sub-title,
            .shop-cart-item-del,
            .v-input__slot
                font-weight bold
                color: #D32F2F !important

    /*SHOPPING DELIVERY*/
    .shop-delivery-choices
        margin-top: 0px

        .v-input__control
            width 100%

        .shop-delivery-location
            cursor pointer
            font-weight: 500;

        .shop-delivery-location:hover
            text-decoration underline


    /****************************************** START NAZ APP*************************************************************/
    /*#content-app-ui
        background: #ffffff !important
        color: #EC0501 !important

        .theme--dark.v-label
            color: #EC0501 !important

        .theme--dark.v-input:not(.v-input--is-disabled) input
            color: #424242 !important
            caret-color: #EC0501 !important

        .theme--dark.v-input--is-disabled input
            color: #7a7a7a !important;

        .theme--dark.v-select .v-select__selections
            color: #424242 !important

        .theme--dark.v-icon
            color: #EC0501 !important

        .theme--dark.v-input--checkbox .v-label
            color: #424242 !important

        .v-expansion-panel__header
            color: #EC0501 !important

        .v-toolbar__content
            border-bottom: 0
            margin-left: 0
            margin-right: 0

        .v-toolbar__content .v-icon
            color: #FFFFFF !important

        .v-btn__content
            color: #EC0501 !important

        .v-btn.primary
            background-color: #ec0501 !important

        .v-btn.primary .v-btn__content,
        .v-btn.primary .v-icon
            color: #FFFFFF !important

        .primary
            color: #fff

        .theme--dark.v-sheet
            color: #ff4f56 !important

        .error--text
            color: #e57373 !important
            caret-color: #e57373 !important

        .v-list__tile
            //color: #ff4f56 !important
            color: #ec0501 !important

        .v-list .v-list__tile__sub-title
            //color: #EC0501 !important
            color: #424242 !important

        .v-navigation-drawer .v-list > div
            margin-top: 0 !important
            margin-bottom: 0 !important
            padding-top: 18px !important
            padding-bottom: 18px !important
            border-bottom: 1px solid


        .theme--dark.v-text-field > .v-input__control > .v-input__slot::before
            border-color: #ff4f56 !important

        .v-text-field > .v-input__control > .v-input__slot:after,
        .v-text-field > .v-input__control > .v-input__slot:after
            border-color: #EC0501 !important

        .fa-angle-double-right::before
            content: "\f105"

        .v-carousel .v-btn .v-btn__content .v-icon
            color: transparent !important

        #points
            width: 150px
            height: 150px
            background-size: contain

        #points h2,
        #points h3
            color: #FFFFFF !important

        .home-username span
            display: block

        .home-spacer2,
        .username-pre,
        .username-pos,
        .storeslist-img,
        .v-navigation-drawer .v-divider
            display: none !important

        .store-list-card
            border-bottom: 2px solid #bdbdbd !important

        .store-list-card .v-icon
            font-size: 30px
            color: #424242 !important
            font-weight: 900

        // FONT SIZES CONFIG

        .v-btn
            font-size: 18px !important;

        h1.home-username
            font-size: 52px

        #points h2
            margin-top: 25px
            font-size: 50px
            line-height: 50px

        .v-list--dense .v-list__tile
            font-size 22px

        .v-toolbar__title
            font-size: 28px;

        .v-input,
        .v-label
            font-size 18px

        .password .v-input__control input
            font-family Helvetica-Light !important;

    html
        font-size: 18px;*/


    /******************************************** END NAZ *************************************************************/
</style>